import { solidstate } from ":setup/qstate";
import { createEffect, createMemo, For, Match, Show, Switch } from "solid-js";
import { explore } from "../apis";
import { Loader2 } from ":src/components/loaders";
import ParticipantsCard from "./participant-card";
import { createInput, createSelect } from ":ui/form";

export default function Participants() {
  const $details = solidstate.createAsync(explore.participants.get);
  const $applied_filter = solidstate.create(
    {} as { search?: string; track?: string; team_type?: string; team_status?: string }
  );
  const $filters = createMemo(() => {
    const result = {
      search: ["first_name", "last_name", "reference"],
      tracks: [],
    };
    const list = $details.value?.participants;
    if (list == undefined) {
      return result;
    }
    for (const item of list) {
      if (item == undefined) {
        continue;
      }
      const track = item.track;
      if (!result.tracks.includes(track)) {
        result.tracks.push(track);
      }
    }

    return result;
  });
  const Search = createInput(null);
  const FilterTrack = createSelect(null);

  createEffect(() => {
    const search = Search.control.value;
    $applied_filter.set((s) => ({ ...s, search: search }));
  });
  createEffect(() => {
    const track = FilterTrack.control.value;
    $applied_filter.set((s) => ({ ...s, track: track }));
  });
  return (
    <section class="flex flex-col w-full h-full gap-y-3 overflow-hidden">
      <span class="text-text-alt text-16px">Only teams can send requests</span>

      <div class="flex flex-row w-full justify-between items-center gap-2  <sm:(!flex-col !gap-x-0)">
        <Search.Input autocomplete="search" class="form-input" placeholder="Search by name,#reference..." />
        <FilterTrack.Select
          class="form-select !w-30% <sm:(!w-full)"
          placeholder="Filter By Track..."
          options={$filters().tracks}
          allowClearSelected
          emptyOptionAlt="No Track"
        />
      </div>

      <Switch>
        <Match when={$details.state.loading}>
          <Loader2 msg="Loading Participants..." />
        </Match>
        <Match when={$details.state.failed}>an error occurred while fetching {$details.error}</Match>
        <Match when={$details.state.success}>
          <div class="grid grid-cols-3 w-full h-full gap-2 overflow-auto  lt-md:(grid-cols-1 !py-1) lt-xl:(grid-cols-2)">
            <For each={$details.value?.participants}>
              {(item) => {
                const show = createMemo(() => {
                  const search_keywords = $filters().search;
                  const search = $applied_filter?.value?.search?.toLowerCase?.();
                  const track = $applied_filter?.value?.track;
                  if (search != undefined) {
                    if (search.startsWith("#")) {
                      const v = search.replace("#", "");
                      console.log("search :: ", v);
                      return item.reference2 != undefined && item.reference2.startsWith(v);
                    } else if (!search_keywords.some((prop) => item[prop]?.toLowerCase().includes(search))) {
                      return false;
                    }
                  }
                  if (track != undefined && item.track !== track) {
                    if (track === "undefined" && item.track == undefined) {
                      return true;
                    }
                    return false;
                  }
                  // if (
                  //   $applied_filter.value.team_type &&
                  //   (($applied_filter.value.team_type === "with team" && !item.team) ||
                  //     ($applied_filter.value.team_type === "without team" && item.team))
                  // ) {
                  //   return false;
                  // }
                  return true;
                });

                return (
                  <Show when={show()}>
                    <ParticipantsCard details={item} team_info={$details.value.team_info} />
                  </Show>
                );
              }}
            </For>
          </div>
        </Match>
      </Switch>
    </section>
  );
}
